class CollectionGrid extends HTMLElement {
  constructor() {
    super();

    this.swiper = new Swiper(this.querySelector('.swiper'), {
      slidesPerView: 'auto',
      slidesPerGroup: 2,
      autoHeight: true,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      spaceBetween: 16,
    });
  }
}

customElements.define('collection-grid', CollectionGrid);

class ProductBundleSwiper extends HTMLElement {
  constructor() {
    super();

    this.swiper = new Swiper(this.querySelector('.product-bundles__swiper'), {
      slidesPerView: 'auto',
      spaceBetween: 16,
      navigation: {
        nextEl: '.product-bundle__swiper-button-right',
        prevEl: '.product-bundle__swiper-button-left',
      },
    });
  }
}

customElements.define('product-bundle-swiper', ProductBundleSwiper);

class BundleVariantPickerSwiper extends HTMLElement {
  constructor() {
    super();

    this.swiper = new Swiper(this.querySelector('.bundle-product-swiper'), {
      slidesPerView: 1,
      pagination: {
        el: '.bundle-swiper-pagination',
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
    });
  }
}

customElements.define('bundle-variant-picker-swiper', BundleVariantPickerSwiper);

class ProductGridSwiper extends HTMLElement {
  constructor() {
    super();

    this.swiper = new Swiper(this.querySelector('.swiper'), {
      slidesPerView: 'auto',
      centeredSlides: true,
      centeredSlidesBounds: true,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      spaceBetween: 8,
      breakpoints: {
        750: {
          spaceBetween: 16,
          slidesPerGroup: 2,
        },
      },
    });
  }
}

customElements.define('product-grid-swiper', ProductGridSwiper);

class HomeBannerSwiper extends HTMLElement {
  constructor() {
    super();
    this.size = Number(this.getAttribute('data-size'));
    console.log('this.size =', this.size);

    this.swiper = new Swiper(
      this.querySelector('.banner-swiper'),
      this.size > 1
        ? {
            pagination: {
              el: '.swiper-pagination',
            },
            navigation: {
              nextEl: '.swiper-button-next',
              prevEl: '.swiper-button-prev',
            },
          }
        : {}
    );
  }
}

customElements.define('home-banner-swiper', HomeBannerSwiper);

class InspiredByCommunitySwiper extends HTMLElement {
  constructor() {
    super();
    this.swiper = new Swiper(this.querySelector('.swiper'), {
      slidesPerView: 'auto',
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      spaceBetween: 8,
      breakpoints: {
        750: {
          spaceBetween: 16,
        },
      },
    });
  }
}

customElements.define('inspired-by-community-swiper', InspiredByCommunitySwiper);

class ShopTheLookSwiper extends HTMLElement {
  constructor() {
    super();
    this.swiper = new Swiper(this.querySelector('.shop-the-look-swiper'), {
      pagination: {
        el: '.swiper-pagination',
      },
      slidesPerView: 'auto',
      spaceBetween: 8,
    });
  }
}

customElements.define('shop-the-look-swiper', ShopTheLookSwiper);

class CollectionHeadSwiper extends HTMLElement {
  constructor() {
    super();
    this.dataCenter = !!this.getAttribute('data-center');

    this.swiper = new Swiper(this.querySelector('.swiper'), {
      slidesPerView: 'auto',
      spaceBetween: 16,
      centeredSlides: true,
      centeredSlidesBounds: true,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
    });
  }
}

customElements.define('collection-head-swiper', CollectionHeadSwiper);

class SwiperContainer extends HTMLElement {
  constructor() {
    super();

    this.swiper = new Swiper(this.querySelector('.swiper'), {
      slidesPerView: 'auto',
      spaceBetween: 8,
      centeredSlides: true,
      centeredSlidesBounds: true,
      breakpoints: {
        750: {
          spaceBetween: 16,
        },
      },
    });
  }
}

customElements.define('swiper-container', SwiperContainer);

class MulticolumnSwiper extends HTMLElement {
  constructor() {
    super();

    this.swiper = new Swiper(this.querySelector('.swiper'), {
      slidesPerView: 'auto',
      spaceBetween: 8,
      centeredSlides: true,
      centeredSlidesBounds: true,
      breakpoints: {
        750: {
          spaceBetween: 16,
        },
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
    });
  }
}

customElements.define('multicolumn-swiper', MulticolumnSwiper);

class ProductDetailSwiper extends HTMLElement {
  constructor() {
    super();
    this.swiper = new Swiper(this.querySelector('.swiper'), {
      slidesPerView: 'auto',
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      centeredSlides: true,
      centeredSlidesBounds: true,
      spaceBetween: 10,
      breakpoints: {
        768: {
          spaceBetween: 20,
        },
        965: {
          spaceBetween: 32,
        },
      },
    });
  }
}

customElements.define('product-detail-swiper', ProductDetailSwiper);
